export default __webpack_public_path__ + "static/uvm_base_class-1f98e21e771f566146c1901a3d17ee72.svg";